import StarRating from 'components/StarRating';
import React from 'react';

const CSS = require('./BookBlockRating.module.scss');

interface BookBlockRatingProps {
  rating: number;
  nrOfReviews: number;
  onReviews: () => void;
}

function BookBlockRating({
  rating = 5,
  nrOfReviews = 0,
  onReviews,
}: BookBlockRatingProps) {
  return (
    <div className={CSS.BookBlockRating}>
      <StarRating
        rating={rating}
        usePartials
        iconClassname={CSS.StarIcon}
        width={14}
        height={14}
      />
      <button className={CSS.NumberOfReviews} onClick={onReviews}>
        {nrOfReviews} review{nrOfReviews > 1 && 's'}
      </button>
    </div>
  );
}

export default BookBlockRating;
